import { Injectable, Inject, LOCALE_ID } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import { DOCUMENT } from '@angular/common';
import { BehaviorSubject } from 'rxjs';
import * as moment from 'moment';

@Injectable({ providedIn: 'root' })
export class LocaleService {
  private current = new BehaviorSubject<string>('en-US');
  public locale$ = this.current.asObservable();

  constructor(@Inject(DOCUMENT) private document: any) {}

  async setLocale(locale: string) {
    console.log(`Setting locale to: ${locale}`);

    // Check if the locale is already set
    if (this.current.value === locale) {
      return;
    }

    let data = [];
    if (locale === 'pl') {
      data = (await import('@angular/common/locales/pl')).default;
    } else {
      data = (await import('@angular/common/locales/en')).default;
      locale = 'en';
    }
    registerLocaleData(data, locale);
    moment.locale(locale);

    // Add other locales as needed
    this.current.next(locale);

    // (Optional) Set lang attribute on html
    this.document.documentElement.lang = locale;
  }
}
